
import { computed, defineComponent, inject, reactive } from 'vue'

export default defineComponent({
  name: 'EditableBlockIbanInput',
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
    },
    modelValue: {
      type: String,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
  },

  setup (props, { emit }) {

    const inputState = reactive({
      label: computed(() => props.label),
      value: computed({
        set: (newValue) => emit('update:modelValue', newValue),
        get: () => props.modelValue,
      })
    })

    const editing = inject('editing', false)

    const formatIBANLabel = (iban: string) => {
      return /([A-Z]{2})([0-9]{2})([A-Z]{4})([0-9]{4})([0-9]{4})([0-9]{2})/.exec(iban)?.slice(1,7).join(' ') || iban
    }

    return {
      editing,
      inputState,
      formatIBANLabel
    }
  }
})
